
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 10","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.566 1.535a1.938 1.938 0 00-2.74 0v.14l7.498 7.499h.142l7.501-7.498v-.142a1.935 1.935 0 00-2.737 0L8.4 6.366l-4.833-4.83z","fill-rule":"nonzero","fill":"#000"}})])
          )
        }
      }
    